import {useContext, useState} from 'react'
import DeleteProductBadgeModal from '../modals/DeleteProductBadgeModal'
import {ProductBadgesPageContext} from '../../context'
import {useNavigate} from 'react-router-dom'

const ProductBadgesTableActionsMenu = ({row: badge}: any) => {
  const {toggleProductBadgeStatus} = useContext(ProductBadgesPageContext)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const navigate = useNavigate()

  return [
    {
      label: 'Edit',
      onClick: () => navigate(`/products/product-badges/${badge.id}/${badge.displayName}`),
      show: true,
    },
    {
      label: badge.status === 'active' ? 'Inactive' : 'Active',
      onClick: () =>
        toggleProductBadgeStatus(badge.id, badge.status === 'active' ? 'inactive' : 'active'),
      show: true,
    },
    {
      label: 'Delete',
      onClick: () => setShowDeleteModal(true),
      render: showDeleteModal && (
        <DeleteProductBadgeModal badge={badge} onClose={() => setShowDeleteModal(false)} />
      ),
    },
  ]
}

export default ProductBadgesTableActionsMenu
